module.exports = __webpack_public_path__ + "static/img/strategy-bigloin.4c18440e.png";